import { render, staticRenderFns } from "./landdetail.vue?vue&type=template&id=765e1d76"
import script from "./landdetail.vue?vue&type=script&lang=js"
export * from "./landdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports